import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Equipment } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdministrativeService extends BaseApiService<Equipment> {
  get cacheKey(): StorageKey {
    return StorageKey.administrativeServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.omniaCoreApiUrl}/v1/user/adminroles`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  paginate(params = {}, operation) {
    const url = `${environment.omniaCoreApiUrl}/v1/user/adminroles`;
    const httpParams = new HttpParams({
      fromObject: params as { [params: string]: string }
    });
    const req: Observable<any> = this.http.get(url, { params: httpParams });
    return req.pipe(
      catchError((responseError) => this.handleError(responseError))
    ).toPromise();
  }

  async removeRelationUserAdminPermission(relationId: number) {
    const url = `${environment.omniaCoreApiUrl}/v1/userAdminPermission/removeUserAdminPermission/${relationId}`;
    const req: Observable<any> = this.http.delete(url);
    return req.pipe(
      catchError((responseError) => this.handleError(responseError))
    ).toPromise();
  }

  async listAdminPermissions() {
    const url = `${environment.omniaCoreApiUrl}/v1/userAdminPermission`;
    const req: Observable<any> = this.http.get(url);
    return req.pipe(
      catchError((responseError) => this.handleError(responseError))
    ).toPromise();
  }

  async addAdminPermissionIntoUser(userId: number, permissionId: number) {
    const url = `${environment.omniaCoreApiUrl}/v1/userAdminPermission/addPermissionIntoUser/${userId}/${permissionId}`;
    const req: Observable<any> = this.http.post(url, {});
    return req.pipe(
      catchError((responseError) => this.handleError(responseError))
    ).toPromise();
  }

  protected parse(obj) {
    return Equipment.parse(obj);
  }

  protected unparse(obj) {
    return Equipment.unparse(obj);
  }
}
